module.exports = __webpack_public_path__ + "static/img/pc_block.8c21cc42.png";